module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTIgMGgyMGMxLjEgMCAyIC45IDIgMnYyMGMwIDEuMS0uOSAyLTIgMkgyYy0xLjEgMC0yLS45LTItMlYyQzAgLjkuOSAwIDIgMHoiIGZpbGw9IiM1NDU2ZmYiLz48cGF0aCBkPSJNMTcgOC41bC02LjggN0w3IDEyLjciIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/checkbox-checked.svg
// module id = 1683
// module chunks = 5